import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>
                <span>PataPay</span>
              </h1>
            </TextWithHighlight>
            <strong>Fast, seamless and secure payments for your pet care business</strong>
            <p>
              Access online and in-person payments with ease
              <br />
            </p>
            {/* <p>
              <strong>Sign up for free </strong>
              to transform your pet care business today.
            </p> */}

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Join Pata</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          {/* <Image
            src={`${VITE_CDN_BASE_URL}/images/image-phone-laptop-app.webp`}
            alt="Preview of Pata Partner app on iPad"
            height={2000}
            width={2000}
          /> */}
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
